import React from 'react';
import PropTypes from 'prop-types';

export const Input = React.forwardRef(
  ({ type = 'text', name, onClick, onChange, disabled = false, required = false, ...rest }, ref) => {
    return (
      <>
        <input
          ref={ref}
          type={type}
          name={name}
          onClick={onClick}
          onChange={onChange}
          disabled={disabled}
          required={required}
          {...rest}
        />
      </>
    );
  }
);

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'password', 'number', 'file', 'checkbox', 'radio', 'date', 'tel', 'url']),
  name: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool
};

Input.defaultProps = {
  type: 'text',
  name: undefined,
  onChange: undefined,
  onClick: undefined,
  disabled: false,
  required: false
};
